import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';

import { AppConfig } from '../AppConfig';
import { AppButton } from '../common/components/AppButton';
import { Helper } from '../common/helpers/Helper';
import { AppHelper } from '../helpers/AppHelper';

export class Home extends Component {
  getHomeContent = () => {
    const images = [
      {
        id: 1,
        img: require('../assets/images/n1.png')
      },
      {
        id: 2,
        img: require('../assets/images/n2.png')
      }
    ]

    return (
      <div className={css(Styles.contentContainer)}>
        {images && images.map((item, index) => {
          return (
            <div key={item.id} className={css(Styles.imageContainer)}>
              <img
                src={item.img}
                alt={Helper.getString('explainerImageAlt')}
                className={css(Styles.img)}
                width={400}
                height={400}
              />
            </div>
          )
        })}
        <div className={css(Styles.textAndButtonContainer)}>
          <Link to='/login' className={css(Styles.link)}>
            <AppButton buttonText={Helper.getString('accessConsole')}
              buttonStyle={Styles.button}
              buttonTextStyle={Styles.buttonTextStyle} />
          </Link>
          <p className={css(Styles.homeText)}>{Helper.getString('homeTagline')}</p>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className={css(Styles.container)}>
        <div className={css(Styles.innerContainer)}>
          {!AppHelper.isOohConsoleHost() &&
            <div className={css(Styles.logoContainer)}>
              <Link to={'/'}>
                <img src={require('../assets/images/dolphin-logo-white.png')}
                  alt={AppConfig.NAME} className={css(Styles.img)} width='250' height='100' />
              </Link>
            </div>
          }
          {this.getHomeContent()}
        </div>
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  container: {
    width: '100%',
    backgroundColor: 'black', // xAppConfig.TINT_COLOUR,
    display: 'flex',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: '0px 25px'
  },
  innerContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    maxWidth: 1310,
    position: 'relative',
    justifyContent: 'center',
    '@media(max-width: 767px)': {
      padding: '0px 20px',
    }
  },
  logoContainer: {
    width: 250,
    position: 'absolute',
    top: 30,
    '@media(max-width: 767px)': {
      width: 150,
      top: 10
    }
  },
  img: {
    width: 'auto',
    height: 'auto',
    maxHeight: '100%',
    maxWidth: '100%',
    borderRadius: 18
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 50,
    marginBottom: 50,
    '@media(max-width: 1023px)': {
      flexDirection: 'column',
      marginTop: 85,
      marginBottom: 20,
      alignItems: 'center'
    }
  },
  imageContainer: {
    width: 400,
    height: 400,
    borderRadius: 16,
    marginRight: 34,
    '@media(min-width: 1024px) and (max-width: 1200px)': {
      width: 300,
      height: 300
    },
    '@media(max-width: 1023px)': {
      width: 200,
      height: 200,
      borderRadius: 12,
      marginRight: 'unset',
      marginBottom: 10
    }
  },
  textAndButtonContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    '@media(max-width: 767px)': {
      justifyContent: 'unset',
      alignItems: 'center'
    }
  },
  button: {
    background: '#DA0389',
    borderRadius: 16,
    width: 182,
    height: 54
  },
  buttonTextStyle: {
    color: '#ffffff',
  },
  homeText: {
    margin: 0,
    marginTop: 24,
    fontSize: 18,
    fontWeight: 600,
    color: '#ffffff',
    maxWidth: 267,
    '@media(max-width: 767px)': {
      marginTop: 14,
      fontSize: 14,
      maxWidth: 180,
      textAlign: 'center'
    }
  },
  link: {
    textDecoration: 'none',
    width: 'fit-content'
  }
})


// WEBPACK FOOTER //
// ./src/screens/Home.js